import React, { useMemo } from 'react'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { shallowEqual, useSelector } from 'react-redux'
import { hasValue } from 'utils/NumberUtil'
import AEPOverview from 'quality/components/AEPoverview/AEPOverview'
import { useParams } from 'react-router'
import useActions from 'utils/customHook/useActions'
import sandre from 'assets/pictures/logos/sandre.png'
import mtes from 'assets/pictures/logos/mtes.png'
import useSandreList from 'utils/customHook/useSandreList'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import { compact } from 'lodash'

const CatchmentAEPApp = () => {
    const { id } = useParams()
    const {
        catchment,
        qualitometers,
    } = useSelector(store => ({
        catchment: store.CatchmentReducer.catchment,
        qualitometers: store.QualityReducer.qualitometersLight,
    }), shallowEqual)

    const agencies = useSandreList(SANDRE.AGENCES)

    useTitle(() => [{
        title: i18n.catchment,
        href: 'catchment',
    }, {
        title: catchment.code ? `[${catchment.code}] ${catchment.name ?? ''}` : catchment.name || i18n.unknown,
        href: `station/catchment/${id}`,
    }, {
        title: i18n.AEPoverview,
        href: `station/catchment/${id}/conformityOverview`,
    }], [catchment])

    useActions(() => {
        const agency = agencies.find(a => a.code === catchment.pond)
        const ref = agency?.mnemonique || agency?.reference
        const mtesLink = ref ? {
            img: mtes,
            href: `http://www.deb.developpement-durable.gouv.fr/telechargements/fiche.php?IG=${ref}_${catchment.code}`,
            label: i18n.mtes,
        } : undefined
        const sandreLink = catchment.sandreCode ? {
            img: sandre,
            href: `https://id.eaufrance.fr/AAC/${catchment.sandreCode}`,
            label: i18n.sandre,
        } : undefined
        const links = compact([mtesLink, sandreLink])
        return {
            links,
        }
    }, [catchment])

    const ids = useMemo(() => {
        const qualito = catchment.catchmentPoints?.map(point => qualitometers.find(p => p.code === point.codeWithoutDesignation)) || []
        return qualito.filter(q => hasValue(q)).map(q => q.id)
    }, [catchment.catchmentPoints, qualitometers])

    return (
        <AEPOverview
            ids={ids}
        />
    )
}

export default CatchmentAEPApp